import { useDispatch, useSelector } from 'react-redux';
import { Drawer, Typography } from '@navi/web-ui/lib/primitives';
import { RootState } from '@cp/src/store';
import styles from './index.module.scss';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import ValidationCard from './ValidationCard';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchInputValidations } from '../../actions/FieldAllocationAction';
import dayjs from 'dayjs';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { FIELD_ALLOCATION_KEY } from '../../types';
import { ValidationData } from '../../interface';

const LiveValidationsDrawer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = readQueryParams();
  const showLiveValidationsDrawer = queryParams[FIELD_ALLOCATION_KEY]?.showLiveValidationsDrawer;

  const inputValidations = useSelector(
    (state: RootState) => state.fieldAllocation?.inputValidations
  );
  const { data = [], loading, lastUpdated } = inputValidations || {};

  const closeLiveValidationsDrawer = () => {
    const updatedTableParams = { ...queryParams };
    delete updatedTableParams[FIELD_ALLOCATION_KEY].showLiveValidationsDrawer;
    const url = createQueryParams(updatedTableParams);
    navigate(url, { replace: true });
  };

  useEffect(() => {
    if (showLiveValidationsDrawer) dispatch(fetchInputValidations());
  }, [showLiveValidationsDrawer]);

  return (
    <Drawer
      headerContainerClasses={styles.drawerHeaderContainer}
      customHeaderClass="w-full"
      customHeader={
        <div className="flex items-center justify-between">
          <Typography variant="h3" color="var(--navi-color-gray-c1)">
            Input Validations
          </Typography>
          {lastUpdated ? (
            <Typography variant="h4" className="text-xs" color="var(--navi-color-gray-c3)">
              synced at {dayjs(lastUpdated).format('hh:mm A')}
            </Typography>
          ) : null}
        </div>
      }
      open={showLiveValidationsDrawer}
      onClose={closeLiveValidationsDrawer}
    >
      {loading ? (
        <div className="flex items-center justify-center h-full">
          <CircularLoaderIcon size="md" />
        </div>
      ) : (
        data?.map((item: ValidationData) => <ValidationCard key={item.key} item={item} />)
      )}
    </Drawer>
  );
};

export default LiveValidationsDrawer;
